import React, { useState } from 'react';
import ProgressBar from 'react-bootstrap/ProgressBar';
import Countdown from 'react-countdown';
import { toast } from 'react-toastify';
import Checkbox from 'rc-checkbox';
import 'rc-checkbox/assets/index.css';
import Navbar from '../components/TopNav';
import Footer from '../components/Footer';
import pankake from '../images/buy/pankak.png';
import prostarter from '../images/landing/prostarter.png';
import swap from '../images/buy/swap.png';
import DisclimerModal from '../components/desclimerModal';
import { buyTokens, claimVest, getBlockChainNetworkId, getClaim, getContractUser, getUserBalance } from '../web3Helper';
import { getChainCurrency } from '../utils';
import { toNumber } from '../web3Utils';

const SALE_CONTRACTS = [
  {
    name: 'Pre Sale',
    tokenName: '$MONS',
    contractType: 'MonstersClanPreSale',
    tokensPerWei: 10204,
    allocationSizeEth: 10,
    vestIds: [ 'vest_1', 'vest_2', 'vest_3' ]
  }
];
const ACTIVE_SALE_CONTRACT = SALE_CONTRACTS[0];

const BuyMonos = () => {
  const [isMonos, setMonos] = useState(false);
  const [toggle, setToggle] = useState(false);
  const [agreedToDisclaimer, setAgreedToDisclaimer] = useState(false);
  const [fromValue, setFromValue] = useState(0);
  const [toValue, setToValue] = useState(0);
  const [isLoading, setIsLoading] = useState(false);
  const [userBalance, setUserBalance] = useState(0);
  const [blockChainNetworkId, setBlockChainNetworkId] = useState('');
  const [vests, setVests] = useState([]);
  const [claimsInProcess, setClaimsInProcess] = useState({});


  React.useEffect(() => {
    const tempVests = [];
    for( let { contractType, vestIds, name, tokenName } of SALE_CONTRACTS ) 
      for( let vestId of vestIds ) 
        tempVests.push({ 
          name: name,
          tokenName,
          vestName: vestId.slice(0,1).toUpperCase() + vestId.slice(1).replace('_', ' '),
          contractType,
          vestId,
          releaseTime: 0,
          amount: 0,
          claimedAmount: 0,
          isClaimed: false,
          claimStatus: 'LOADING',
        })
    setVests(tempVests)
    
    getBlockChainNetworkId()
      .then((networkId) =>
        setBlockChainNetworkId(networkId.toString())
      );

    getUserBalance()
      .then((latestUserBalance) => 
        setUserBalance(latestUserBalance)
      );

    Promise.all( 
      tempVests
        .map(({ vestId, contractType }) => 
          getClaim({ vestId, contractType })
        ) 
    ).then((responses) => {
      setVests(
        responses.map( 
          (response, i) => ({
            ...tempVests[i], 
            ...response,
            claimStatus: response.isClaimed ? 'CLAIMED' : !response.releaseTime ? 'NOT_ALLOCATED' : 'UNCLAIMED'
          })
        )
      )
    }).catch((err) => 
      setVests(
        tempVests.map( 
          vest => ({...vest, claimStatus: 'ERROR' })
        )
      )
    )
  }, []);

  React.useEffect(() => {
    const newToValue = parseFloat(fromValue) * ACTIVE_SALE_CONTRACT.tokensPerWei
    setToValue(  isNaN(newToValue) ? 0 : newToValue );
  }, [fromValue]);

  const renderer = ({ days,hours, minutes, seconds, completed }) => {
      const day = days.toString().length === 1 ? 0 : ''
      const hour = hours.toString().length === 1 ? 0 : ''
      const min = minutes.toString().length === 1 ? 0 : ''
      const sec = seconds.toString().length === 1 ? 0 : ''
      return (
        <p className="time-p">
         <span className="time">{day}{days}</span> : <span className="time">{hour}{hours}</span> : <span className="time">{min}{minutes}</span> : <span className="time">{sec}{seconds}</span>
        </p>
      );
  };


  const handleSwap = () => {
    
    if(isNaN(Number(fromValue))) return toast.error('Invalid Value!');

    if(!agreedToDisclaimer) return;

    setIsLoading(true);
    getUserBalance()
    .then((latestUserBalance) => {

      setUserBalance(latestUserBalance);

      if( Number(fromValue) > latestUserBalance ) {
        setIsLoading(false);
        return toast.error('Insufficient Balance!');
      }

      buyTokens({
        contractType: ACTIVE_SALE_CONTRACT.contractType,
        value: fromValue
      }).then(() => {
        setIsLoading(false);
        setFromValue(0);
        setToValue(0);
        toast.success('Tokens Bought! The same will be available in some time.');
      })
      .catch((err) =>{
        console.log('ERR', err);
        setIsLoading(false);
        toast.error(typeof err === 'string' ? err : err.message);
      });

    }).catch((err) => {
      setIsLoading(false);
      toast.error(typeof err === 'string' ? err : err.message);
    })
  }

  const isClaimButtonDisabled = (releaseTime) => Math.floor(new Date().getTime()/1000) < releaseTime
  const handleClaimVest = (vest) => {

    if(!isClaimButtonDisabled(vest.releaseTime)) {
      setClaimsInProcess({ 
        ...claimsInProcess, 
        [vest.vestId]: true 
      });
      claimVest({
        vestId: vest.vestId,
        contractType: vest.contractType,
      }).then( async () => {
        toast.success('Vesting claimed successfully, status will be updated in some time.');
        setClaimsInProcess({ 
          ...claimsInProcess, 
          [vest.vestId]: false 
        });
      }).catch( async (e) => {
        if( e.includes && e.includes('Already Claimed')){
          toast.warn('Already Claimed');
        } else {
          toast.error( typeof e === 'string' ? e : e.message );
        }
        setClaimsInProcess({ 
          ...claimsInProcess, 
          [vest.vestId]: false 
        });
      })
    } else {
      toast.error(`Cannot Claim ${vest.name} ${vest.vestName}!`)
    }
  }

  const handleMaxClick = async () => {
    try {
      const user = await getContractUser({ contractType: ACTIVE_SALE_CONTRACT.contractType });
      const fromValue = ACTIVE_SALE_CONTRACT.allocationSizeEth - toNumber(user.totalEthRaised);
      setFromValue( userBalance > fromValue ? fromValue > 0 ? fromValue : 0 : userBalance )
    } catch(err) {
      toast.error(typeof err === 'string' ? err : err.message);
    }
  }

  return (
    <div className="row no-gutters buy-monos">
      <Navbar />
      <div className="col-12 main">
        <DisclimerModal toggle={toggle} onCloseModal={()=>setToggle(false)} />
        <span className="heading">PRIVATE & PUBLIC SALE ROUNDS</span>
        <p>Have a look at the $MONS sale schedule and avail this golden opportunity to
           grab $MONS before it's too late.</p>
        <div className="row no-gutters cards-row">
          <div className="col-lg-4 col-sm-12">
            <div className="heading-box">
              <h5>PRIVATE SALE</h5>
            </div>
            <div className="card first-card">
              <h1>SEED ROUND</h1>
              <span>TOTAL RAISE</span>
              <h4>$1,050,000</h4>
              <p className="text">Have a look at the $MONS sale schedule and avail this golden opportunity
                 to grab $MONS before it's too late.</p>
              <Countdown  renderer={renderer}
              date={new Date(new Date().getUTCFullYear(), new Date().getUTCMonth() + 2,  0, 23, 59, 50, 100).getTime()} />
              <ProgressBar animated now={50}/>
              <p className="progress-p">0 / $350,000</p>
              <button className="btn buy">Get in Touch</button>
            </div>
          </div>
          <div className="col-lg-8 col-sm-12">
            <div className="public-box">
              <h5>PUBLIC SALE</h5>
            </div>
            <div className="row no-gutters">
              <div className="col-lg-6 col-sm-12">
                {!isMonos &&  <div className="card">
                <h1>PRE SALE</h1>
                <span>TOTAL RAISE</span>
                <h4>$2,000,000</h4>
                <div className="mid-div">
                  <div>
                    <span>MIN. ALLOCATION</span>
                    <h4>1 BNB</h4>
                  </div>
                  <div>
                    <span>MAX. ALLOCATION</span>
                    <h4>10 BNB</h4>
                  </div>
                </div>
                <span>STARTS IN</span>
                <Countdown renderer={renderer}
                date={new Date(new Date().getUTCFullYear(), new Date().getUTCMonth() + 2,  0, 23, 59, 50, 100).getTime()} />
                <ProgressBar disabled animated now={50}/>
                <p className="progress-p">0 / $350,000</p>
                <button onClick={()=> setMonos(true)} className="btn buy">BUY $MONS</button>
              </div>
              }
              {isMonos && <div className="card color-card">
                <h1>BUY MONS</h1>
                <div className="amount-div">
                  <p>MONS <span>Amount</span></p>
                  <span>Add to MetaMask</span>
                </div>
                <input placeholder="0.0" readOnly value={toValue} className="form-control"/>
                <button className="btn max" onClick={handleMaxClick.bind(null)}>Max</button>
                <img className="swap" src={swap} alt=""/>
                <div className="amount-div">
                  <p>BNB <span>Amount</span></p>
                  <p><span>Available Balance:</span> <span className="font-weight-bold">{userBalance} {getChainCurrency(blockChainNetworkId)}</span></p>
                </div>
                <input placeholder="0.0" value={fromValue} onChange={(event) => setFromValue(event.target.value)} className="form-control"/>
                <button className="btn max" onClick={handleMaxClick.bind(null)}>Max</button>
                <label>
                  <Checkbox
                    onChange={(event) => setAgreedToDisclaimer(event.target.checked)}
                    type="checkbox"
                  />
                  <div>
                  I agree to the terms & conditions! For more details read <span className="disclimer" onClick={()=> setToggle(true)}>disclaimer</span>.
                  </div>
                </label>
                <button disabled={!agreedToDisclaimer || isLoading} onClick={handleSwap.bind(null)} className="btn buy">
                  {
                    isLoading ? 'Please Wait...' : 'BUY $MONS'
                  }
                </button>
              </div>
              }
              </div>
              <div className="col-lg-6 col-sm-12">
                <div className="card last-card">
                  <h1>IDO ROUND</h1>
                  <span>TOTAL RAISE</span>
                  <h4>$750,000</h4>
                  <span>IDO PARTNERS</span>
                  <div className="partners-div">
                    <img src={prostarter} alt=""/>
                  </div>
                  <Countdown renderer={renderer}
                  date={new Date(new Date().getUTCFullYear(), new Date().getUTCMonth() + 2,  0, 23, 59, 50, 100).getTime()} />
                  <ProgressBar disabled animated now={50}/>
                  <p className="progress-p">0 / $350,000</p>
                  <button disabled className="btn buy">BUY $MONS</button>
              </div>
              
              </div>
            </div>
          </div>
          <div className="col-12">
            <div className="bottome-div">
              <img src={pankake} alt=""/>
              <p>Pancake Swap Listing on Sep 1, 2021
              <span className="warning">*All unsold token will be burnt</span>
              </p>
              
              <Countdown renderer={renderer}
                date={new Date(new Date().getUTCFullYear(), new Date().getUTCMonth() + 2,  0, 23, 59, 50, 100).getTime()} />
            </div>
          </div>
        </div>
        <div className="row no-gutters cards-row accumulations">
          <div className="col-12">
            <h3>
              Accumulations
            </h3>
            <div className="row mx-0 mb-2 w-100 no-gutters cards-row">
              <div className="col-12">
                <div className="public-box d-flex justify-content-around">
                  <div className="vest-head-item">
                    Name
                  </div>
                  <div className="vest-head-item">
                    Token Name
                  </div>
                  <div className="vest-head-item">
                    Tokens
                  </div>
                  <div className="vest-head-item">
                    Time Left
                  </div>
                  <div className="vest-head-item">
                    Action
                  </div>
                </div>
              </div>
            </div>
            {
              vests.map((vest) => 
                <div className="row mx-0 my-2 w-100 no-gutters cards-row">
                  <div className="col-12">
                    <div className="card flex-row justify-content-around">
                      <div className="vest-item">
                        {vest.name} {vest.vestName}
                      </div>
                      <div className="vest-item">
                        {vest.tokenName}
                      </div>
                      <div className="vest-item">
                        {vest.amount}
                      </div>
                      <div className="vest-item">
                        {
                          vest.releaseTime 
                          ? <Countdown date={new Date(vest.releaseTime).getTime()} />
                          : '-'
                        }
                      </div>
                      <div>
                        {
                          vest.claimStatus === 'LOADING' ? 
                           <span className="badge badge-info">Loading...</span> 
                          : vest.claimStatus === 'ERROR' || vest.claimStatus === 'NOT_ALLOCATED' ? 
                            <span className="badge badge-warning">Unavailable</span> 
                          : vest.claimStatus === 'CLAIMED' ? 
                            <span className="badge badge-success">Claimed</span> 
                          : <button className="btn buy" onClick={handleClaimVest.bind(null, vest)} disabled={isClaimButtonDisabled(vest.releaseTime) || !!claimsInProcess[vest.vestId]} >
                            {
                              claimsInProcess[vest.vestId] ? 'Please Wait...' : 'Claim' 
                            }
                          </button>
                        }
                      </div>
                    </div>
                  </div>
                </div>
              )
            }
          </div>
        </div>
      </div>
      
      <Footer />
     </div>
  )
}

export default BuyMonos;